<template>
  <div>
    <md-card>
      <md-card-header md-alignment="space-between">
        <h4 class="title"><md-icon>search</md-icon>검색 조건</h4>
      </md-card-header>
      <md-card-content>
        <table class="flex-table">
          <colgroup>
            <col width="12%" />
            <col width="13%" />
            <col width="12%" />
            <col width="13%" />
            <col width="12%" />
            <col width="13%" />
            <col width="12%" />
            <col width="13%" />
          </colgroup>
          <tr>
            <th>대상학기</th>
            <td>
              <select v-model="searchQuery.semesterCd" name="semesterCd">
                <option value="">선택</option>
                <option
                  v-for="item in semesterCdList"
                  :key="item.code"
                  :label="item.codeNm"
                  :value="item.code"
                >
                  {{ item }}
                </option>
              </select>
            </td>
            <th>교우성명</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.memberHnm"
                v-on:keyup.enter="sendQuery"
              />
            </td>
            <th>교우번호</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.memberNo"
                v-on:keyup.enter="sendQuery"
              />
            </td>
            <!-- <th>섭외담당자</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.agreemFindmanCd"
                v-on:keyup.enter="sendQuery"
              />
            </td> -->
            <th>약정구좌수</th>
            <td>
              <input
                type="number"
                v-model.number="searchQuery.minAmount"
                v-on:keyup.enter="sendQuery"
                placeholder="from"
                @input="onlyNumber('minAmount', $event)"
                @blur="setAgreemAmount('min')"
              />
              ~
              <input
                type="number"
                v-model.number="searchQuery.maxAmount"
                v-on:keyup.enter="sendQuery"
                placeholder="to"
                @input="onlyNumber('maxAmount', $event)"
                @blur="setAgreemAmount('max')"
              />
            </td>
          </tr>
          <tr>
            <th>약정금액</th>
            <td>
              <input
                type="number"
                v-model.number="searchQuery.minAgreemAmount"
                v-on:keyup.enter="sendQuery"
                placeholder="from"
                @input="onlyNumber('minAgreemAmount', $event)"
              />
              ~
              <input
                type="number"
                v-model.number="searchQuery.maxAgreemAmount"
                v-on:keyup.enter="sendQuery"
                placeholder="to"
                @input="onlyNumber('maxAgreemAmount', $event)"
              />
            </td>
            <th>지급조건</th>
            <td>
              <input
                type="text"
                v-model="searchQuery.conditionGive"
                v-on:keyup.enter="sendQuery"
              />
            </td>
            <th>지정/미지정</th>
            <td>
              <label
                ><input
                  type="radio"
                  name="designateGb"
                  value="Y"
                  v-model="searchQuery.designateGb"
                  v-on:keyup.enter="sendQuery"
                />Y</label
              >
              <label
                ><input
                  type="radio"
                  name="designateGb"
                  value="N"
                  v-model="searchQuery.designateGb"
                  v-on:keyup.enter="sendQuery"
                />N</label
              >
            </td>
            <th>학생배정여부</th>
            <td>
              <label
                ><input
                  type="radio"
                  name="matchYn"
                  value="Y"
                  v-model="searchQuery.matchYn"
                  v-on:keyup.enter="sendQuery"
                />Y</label
              >
              <label
                ><input
                  type="radio"
                  name="matchYn"
                  value="N"
                  v-model="searchQuery.matchYn"
                  v-on:keyup.enter="sendQuery"
                />N</label
              >
            </td>
          </tr>
        </table>
      </md-card-content>

      <md-card-actions md-alignment="right">
        <md-button class="md-info md-sm" @click="sendQuery">
          <md-icon>check</md-icon>검 색
        </md-button>
        <md-button class="md-default md-sm" @click="clearQuery">
          <md-icon>clear</md-icon>초기화
        </md-button>
        <md-button
          class="md-success md-sm"
          :disabled="this.pagination.total === 0"
          @click="downloadExcel"
          v-exel-btn="[5, 3]"
        >
          <md-icon>get_app</md-icon>Excel 다운로드
        </md-button>
      </md-card-actions>
    </md-card>

    <!-- 목록 시작 -->
    <md-card>
      <md-card-content>
        <div class="table-header-info">
          <div>총 {{ total }} 건의 검색결과가 있습니다.</div>
          <div>
            <select
              v-model="pagination.perPage"
              name="pages"
              @change="perPageChange"
            >
              <option
                v-for="item in pagination.perPageOptions"
                :key="item"
                :label="item"
                :value="item"
              >
                {{ item }}
              </option>
            </select>
          </div>
        </div>

        <grid
          ref="SchaDonorList"
          :data="gridProps.data"
          :columns="gridProps.columns"
          :options="gridProps.options"
          :theme="gridProps.theme"
          :rowHeaders="gridProps.rowHeaders"
          :columnOptions="gridProps.columnOptions"
          :language="gridProps.lang"
          @click="onClickRow"
          @response="response"
        ></grid>
      </md-card-content>

      <slot name="bottomRightArea"></slot>
    </md-card>
  </div>
</template>
<script>
import formatter from "@/kuaa/kuaa-formatter";
import kuaaApi from "@/kuaa/kuaa-api";
import URL_CONST from "@/kuaa/kuaa-url-const";
import kuaaFnc from "@/kuaa/kuaa-comm-func";
import session from "@/kuaa/kuaa-sessions";

import Swal from "sweetalert2";
import moment from "moment";

import { Grid } from "@toast-ui/vue-grid";
import "tui-grid/dist/tui-grid.css";
import "tui-pagination/dist/tui-pagination.css";

export default {
  name: "SchaDonorListComp",

  props: {},

  components: {
    grid: Grid
  },

  created() {
    this.getSemesterCdList();
    this.initGrid();
  },

  computed: {
    total() {
      return this.pagination.total;
    }
  },
  data() {
    return {
      searchQuery: {
        semesterCd: this.$route.query.semesterCd, // 학기
        memberNo: this.$route.query.memberNo,
        memberHnm: "",
        agreemFindmanCd: "", //섭외담당자
        designateGb: null, // 지정미지정
        matchYn: null,
        levelNm: "",
        conditionGive: "", // 지급조건
        maxAgreemAmount: null, // 약정금액 최대
        minAgreemAmount: null, // 약정금액 최소
        minAmount: null, // 약정구좌수 최소
        maxAmount: null, // 약정구좌수 최대
      },
      semesterCdList: [],
      gridProps: {},
      pagination: {
        perPage: 500,
        page: 1,
        perPageOptions: [800, 500, 200, 100, 50, 20],
        total: 0
      }
    };
  },
  mounted() {
    if (this.$route.query.semesterCd) {
      this.sendQuery();
      this.$emit("returnResult", e.instance.getRow(e.rowKey));
    }
  },
  methods: {
  onlyNumber(field, event) {
    // 숫자와 소수점만 허용 (단, 소수점은 1개만)
    let value = event.target.value.replace(/[^0-9.]/g, '');
    // 소수점이 여러 개 입력되는 것을 방지
    const parts = value.split('.');
    if (parts.length > 2) {
      value = parts[0] + '.' + parts.slice(1).join('');
    }
    this.searchQuery[field] = value ? Number(value) : null;
    
    // 약정구좌수가 변경되면 즉시 약정금액 계산
    if (field === 'minAmount') {
      this.setAgreemAmount('min');
    } else if (field === 'maxAmount') {
      this.setAgreemAmount('max');
    }
  },
  setAgreemAmount(type) {
    const val = type === 'min' ? this.searchQuery.minAmount : this.searchQuery.maxAmount;
    const targetField = type === 'min' ? 'minAgreemAmount' : 'maxAgreemAmount';
    this.searchQuery[targetField] = (typeof val === 'number' && !isNaN(val)) ? val * 4000000 : null;
  },
    getSemesterCdList() {
      kuaaFnc.fncSemesterCodes(null, res => {
        this.semesterCdList = res.data.data.contents;
      });
    },
    sendQuery(isReset) {
      this.$refs.SchaDonorList.invoke(
        "readData",
        this.$refs.SchaDonorList.invoke("getPagination")._currentPage,
        this.searchQuery
      );
      if (isReset) this.$emit("resetView"); // 부모 화면 초기화
    },

    clearQuery() {
      this.searchQuery.semesterCd = "";
      this.searchQuery.memberNo = "";
      this.searchQuery.memberHnm = "";
      this.searchQuery.agreemFindmanCd = "";
      this.searchQuery.designateGb = null;
      this.searchQuery.matchYn = null;
      this.searchQuery.levelNm = "";
      this.searchQuery.conditionGive = "";
      this.searchQuery.minAgreemAmount = null;
      this.searchQuery.maxAgreemAmount = null;
      this.searchQuery.minAmount = null;
      this.searchQuery.maxAmount = null;
    },

    initGrid() {
      this.gridProps = kuaaFnc.setGridInit(
        URL_CONST.GET_SCHA_DONOR_LIST,
        false,
        this.pagination
      );
      this.gridProps["el"] = this.$refs.SchaDonorList;
      this.gridProps["columns"] = [
        {
          header: "대상학기",
          name: "semesterCdNm",
          align: "center",
          width: 100,
          sortable: true
        }, //, hidden: true
        {
          header: "성명",
          name: "memberHnm",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "교우번호",
          name: "memberNo",
          align: "center",
          width: 100,
          sortable: true,
          formatter(value) {
            return `<span style="color:#0091d5; tcursor:pointer">${value.value}</span>`;
          }
        },
        { header: "학과", name: "classNm", width: 100, sortable: true },
        {
          header: "학번",
          name: "hakbun",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "졸업회수",
          name: "graduationNo",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "직위",
          name: "memberorgGbNm",
          align: "center",
          sortable: true
        },
        {
          header: "약정구좌수",
          name: "",
          align: "right",
          width: 95,
          sortable: false,
         formatter(value) {
            const amount = value.row.agreemAmount;
            if (amount) {
              // parseFloat은 문자열의 쉼표를 무시하고 숫자만 추출
              const numAmount = typeof amount === 'number' ? amount : parseFloat(amount.toString().replace(/,/g, ''));
              return (numAmount / 4000000).toFixed(2);
            }
            return "";
          }
        },
        {
          header: "약정금액",
          name: "agreemAmount",
          align: "right",
          width: 120,
          sortable: true,
          formatter(value) {
            return formatter.getCurrency(value.value);
          }
        },
        {
          header: "실입급액",
          name: "giveAmount",
          align: "right",
          width: 120,
          sortable: true,
          formatter(value) {
            return formatter.getCurrency(value.value);
          }
        },
        {
          header: "기부금(기본재산)",
          name: "baseAmount",
          align: "right",
          width: 130,
          sortable: true,
          formatter(value) {
            return formatter.getCurrency(value.value);
          }
        },
        {
          header: "섭외담당자",
          name: "agreemFindmanCd",
          align: "center",
          width: 120,
          sortable: true
        },
        {
          header: "실무담당자",
          name: "managerNm",
          align: "center",
          width: 120,
          sortable: true
        },
        {
          header: "실무담당자부서/직위",
          name: "levelNm",
          align: "center",
          width: 150,
          sortable: true
        },
        {
          header: "실무담당자전화번호",
          name: "memberCellular",
          align: "center",
          width: 145,
          sortable: true,
          formatter(value) {
            return value.value != null
              ? formatter.getPhoneMask(value.value)
              : value.value;
          }
        },
        {
          header: "실무담당자이메일",
          name: "eMail",
          width: 135,
          sortable: true
        },
        {
          header: "지급조건",
          name: "conditionGive",
          align: "center",
          width: 100,
          sortable: true
        },
        {
          header: "세부조건",
          name: "conditionDetail",
          align: "center",
          width: 100,
          sortable: true
        },
        { header: "비고", name: "conditionEtc", width: 200, sortable: true },
        {
          header: "저장일시",
          name: "insertDate",
          align: "center",
          width: 130,
          sortable: true
        },
        {
          header: "수정일시",
          name: "updateDate",
          align: "center",
          width: 130,
          sortable: true
        },
        { header: "applySeqNo", name: "applySeqNo", hidden: true }
      ];
      this.gridProps["options"].bodyHeight = 300;
      this.gridProps["columnOptions"].frozenCount = 8;
    },
    perPageChange(event) {
      kuaaFnc.resetPagenation(this.$refs.SchaDonorList, event, this.pagination);
    },
    response(e) {
      console.log("response = ", e);
      let res = JSON.parse(e.xhr.response);
      if (res.result) {
        this.pagination.total = res.data.pagination.totalCount;
        this.$emit("returnQueryResult", this.searchQuery);
        this.$emit("returnPagingResult", this.pagination);
      } else {
        kuaaFnc.gridErrorCallback(e);
      }
      this.$refs.SchaDonorList.invoke("refreshLayout");
    },
    onClickRow(e) {
  console.log("onClickRow = ", e);
  if (e.instance.getRow(e.rowKey) != null && e.columnName == "memberNo") {
    const row = e.instance.getRow(e.rowKey);
    this.$emit("returnResult", row);
    this.$emit("updateSum", {
      totalAgreemAmount: row.totalAgreemAmount ?? 0,
      totalRealAmount: row.totalGiveAmount ?? 0,
      totalFundAmount: row.totalBaseAmount ?? 0
    }); 
  }
},

    downloadExcel() {
      this.searchQuery.page = 1;
      this.searchQuery.perPage = this.pagination.total;
      this.searchQuery.fileName = "기부자 관리";
      kuaaApi.requestFileDownload(
        URL_CONST.SCHA_APPLY_DONOR_EXCEL_DOWNLOAD,
        this.searchQuery,
        "기부자 관리.xlsx",
        response => {
          this.searchQuery.page = this.pagination.page;
          this.searchQuery.perPage = this.pagination.perPage;
        }
      );
    }
  }
};
</script>

<style lang="css" scoped></style>
<style scoped>
input[type="number"]{
  width: 100px;
}
</style>
